/*
Copyright (C) 2009 - 2019 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import React from 'react';
import { get } from 'lodash';
import { Helmet as ReactHelmet } from 'react-helmet';

import {
  useFormatMessage,
  useGtmPageView,
  useNationalSiteContext
} from 'app/common/hooks';
import { useContentInfo, useContentModel } from 'app/content/hooks';
import { HTMLWidget } from 'app/common/components';

import messages from './TermsOfUse.messages';
import { useHeaderMetadata } from '../../../core/components/App';

const TermsOfUse = () => {
  const formatMessage = useFormatMessage();
  const { partsToGo } = useNationalSiteContext();
  const { termsOfUseModelName } = useContentInfo();
  const { content: contentItem } = useContentModel(termsOfUseModelName);
  const content = get(contentItem, 'fields.termsOfUseContent.value');
  const { siteTitle } = useHeaderMetadata();
  const canonical = `${window.location.origin}/terms-of-use`;
  const title = formatMessage(messages.title);

  const defaultDescription = formatMessage(messages.description);
  const dealerDescription = formatMessage(messages.descriptionDealer, {
    dealerName: siteTitle
  });
  const description = partsToGo ? defaultDescription : dealerDescription;
  useGtmPageView('Terms of Use');

  return (
    <main className="container relative flex-grow mx-auto p-4 sm:py-8 md:px-6 lg:px-8">
      <ReactHelmet titleTemplate={`%s - ${siteTitle}`}>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="canonical" content={canonical} />
        <meta name="robots" content="index,follow" />
        <meta property="og:title" content={title} />
        <meta property="og:site_name" content={siteTitle} />
        <meta property="og:type" content="website" />
        <meta property="og:description" content={description} />
        <link rel="canonical" href={canonical} />
      </ReactHelmet>
      {content && <HTMLWidget content={content} />}
    </main>
  );
};

export default TermsOfUse;
export { TermsOfUse };
